/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { Proxy } from '../models/index';
import { ProxyFromJSON } from '../models/index';
import * as runtime from '../runtime';

export interface GetProxyRequest {
  name: string;
}

/**
 *
 */
export class DefinitionApi extends runtime.BaseAPI {
  /**
   * Return response code based on a query parameter
   * Get all details of a proxy
   */
  async getProxyRaw(
    requestParameters: GetProxyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Proxy>> {
    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling getProxy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('bearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/proxy/{name}`;
    urlPath = urlPath.replace(
      `{${'name'}}`,
      encodeURIComponent(String(requestParameters['name'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ProxyFromJSON(jsonValue),
    );
  }

  /**
   * Return response code based on a query parameter
   * Get all details of a proxy
   */
  async getProxy(
    requestParameters: GetProxyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Proxy> {
    const response = await this.getProxyRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
